module.exports = __webpack_public_path__ + "static/img/应用系统开发.7a7a1c97.png";